import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  :host {
    display: block;
  }

  .marquee {
    align-items: center;
    animation-duration: var(--internal-marquee-duration);
    animation-iteration-count: infinite;
    animation-name: scroll;
    animation-play-state: var(--internal-marquee-play);
    animation-timing-function: linear;
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    min-width: auto;
    z-index: 1;
  }

  @keyframes scroll {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  .marquee-container {
    --mask-width: 0px;
    display: flex;
    flex-direction: row;
    mask-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff var(--internal-marquee-mask-width), #ffffff calc(100% - var(--internal-marquee-mask-width)), rgba(255, 255, 255, 0) 100%);
    overflow: hidden;
    position: relative;
    width: 100%;
  }

  .marquee-container:hover div {
    animation-play-state: var(--internal-marquee-pause-on-hover);
  }

  .marquee-initial {
    align-items: center; 
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    min-width: auto;
  }

  .marquee-clone {
    display: contents;
  }
`
